import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// jl-design-system
import Link from 'jl-design-system/elements/link/Link';
import TickInCircle32PxOutlined from 'jl-design-system/elements/icons-jb/TickInCircle32PxOutlined';
import printLogo from '../../assets/images/logos/john-lewis-logo-xmas.svg';

import { openLeaveCheckoutModal } from '../../redux/actions/app/appActions';
import routeConstants from '../../constants/routeConstants';
import returnToJL from '../../utils/helpers/returnToJL';
import shouldShowFullScreenSignUp from '../../utils/myjl/fullScreenSignUp';

// styles
import styles from './header.scss';

export class Header extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool,
    openLeaveCheckoutModal: PropTypes.func,
    order: PropTypes.shape({
      id: PropTypes.string,
    }),
    pathname: PropTypes.string,
    showFullScreenSignUpFlow: PropTypes.bool,
  };

  static defaultProps = {
    isLoading: false,
    openLeaveCheckoutModal: window.defaultFunc,
    order: {},
    pathname: './',
    showFullScreenSignUpFlow: false,
  }

  onLeaveCheckout = () => {
    const { openLeaveCheckoutModal, pathname } = this.props;
    openLeaveCheckoutModal(pathname);
  }

  checkIfShowLeaveCheckoutModalForRoute = (currentPath) => {
    if (
      currentPath.includes(routeConstants.DELIVERY) ||
      currentPath.includes(routeConstants.CLICK_AND_COLLECT) ||
      currentPath.includes(routeConstants.PAYMENT)
    ) {
      return true;
    }
    return false;
  }

  render() {
    const {
      isLoading,
      order,
      pathname,
      showFullScreenSignUpFlow,
    } = this.props;

    return (
      <>
        <header className={styles.header} data-test="app-header">
          <div className={styles.container}>
            <img
              alt="John Lewis & Partners"
              className={styles.printLogo}
              src={printLogo}
            />
            {
              this.checkIfShowLeaveCheckoutModalForRoute(pathname) &&
              (
                <button
                  className={styles.headerLogoLink}
                  data-test="header-logo-link"
                  onClick={this.onLeaveCheckout}
                  type="button"
                >
                  <span className={styles.visuallyHiddenText}>John Lewis</span>
                </button>
              )
            }
            {
              !this.checkIfShowLeaveCheckoutModalForRoute(pathname) &&
              (
                <Link
                  className={styles.headerLogoLink}
                  data-test="header-logo-link"
                  external
                  to={returnToJL()}
                >
                  <span className={styles.visuallyHiddenText}>John Lewis</span>
                </Link>
              )
            }

            <div
              className={styles.secureCheckout}
              data-test="header-secure-message"
            >
              <span
                className={styles.smallSecureText}
                data-test="small-secure-text"
              >
                <span className={styles.smallSecureIcon} />
                Secure
              </span>
              <span
                className={styles.largeSecureText}
                data-test="large-secure-text"
              >
                Secure checkout
                <span className={styles.largeSecureIcon} />
              </span>
            </div>
            <p className={styles.printOrderId} data-test="header-order-id">
              Order number: <span><strong>{order.id}</strong></span>
            </p>
          </div>
        </header>
        {
          showFullScreenSignUpFlow &&
          !isLoading &&
          <h1 className={styles.signUpHeading}>
            <TickInCircle32PxOutlined />
            <span className={styles.signUpHeadingText}>Account created</span>
          </h1>
        }
      </>
    );
  }
}

export function mapStateToProps(state) {
  return {
    isLoading: state.app.isLoading,
    order: state.confirmation.order,
    pathname: state.router.location.pathname,
    showFullScreenSignUpFlow: shouldShowFullScreenSignUp(state),
  };
}

export function mapDispatchToProps() {
  return {
    openLeaveCheckoutModal,
  };
}

export default connect(state => mapStateToProps(state), mapDispatchToProps())(Header);
